module.exports = __webpack_public_path__ + "img/driver2.7b7906fd.png";